import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia';
const pinia = createPinia()
pinia.use(piniaPersistedstate)

import { createApp } from 'vue';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import App from './App.vue';
import mitt from 'mitt';
import router from './router';

import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/styles/style.scss'

import {customRu} from "@/helpers/elCustomLocale";


const emitter = mitt();

// Включаем обновление локали для ElementPlus
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ru';

dayjs.extend(updateLocale);
dayjs.updateLocale('ru', {
  weekStart: 1, // Понедельник
});


// Подавление ResizeObserver loop warnings
const debounce = (fn, delay) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), delay)
  }
}

const resizeObserverLoopErr = debounce(() => {
  const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay')
  const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay-div')
  if (resizeObserverErrDiv) {
    resizeObserverErrDiv.setAttribute('style', 'display: none')
  }
  if (resizeObserverErr) {
    resizeObserverErr.setAttribute('style', 'display: none')
  }
}, 50)

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay')
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay-div')
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none')
    }
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none')
    }
    resizeObserverLoopErr()
    e.stopImmediatePropagation()
  }
})

const app = createApp(App);
app.use(pinia)
app.provide('emitter', emitter)
app.use(ElementPlus, {locale: customRu,})
app.use(router);

app.mount('#app');

import { useStore } from "@/state/store";
const store = useStore()
store.setLoaded()
